import { render, staticRenderFns } from "./liveCourse.vue?vue&type=template&id=73a4c656"
import script from "./liveCourse.vue?vue&type=script&lang=js"
export * from "./liveCourse.vue?vue&type=script&lang=js"
import style0 from "./liveCourse.vue?vue&type=style&index=0&id=73a4c656&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports